var map = {
	"./pic-1.jpg": 777,
	"./pic-2.jpg": 778,
	"./pic-3.jpg": 779,
	"./pic-4.jpg": 780,
	"./pic-5.jpg": 781,
	"./pic-6.jpg": 782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 776;